import { defineComponent as _defineComponent } from 'vue'
import { ref as _ref } from 'vue';

import __MACROS_useVModel from "/vue-macros/define-models/use-vmodel";
import { watch } from 'vue';
import { AlertingHookDto, AlertingHookService } from '@/api';

interface Emit {
  (event: 'input', value: AlertingHookDto[]): void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Slack-Tag-Selector',
  props: {
  value: null
},
  emits: ["input"],
  setup(__props, { emit }) {



const { value: selectedSlackChannels } = __MACROS_useVModel(["value", undefined, "input"]);

let loading = _ref(false);
let alertingHooks = _ref<AlertingHookDto[]>([]);
const searchString = _ref('');

const clear = () => {
  selectedSlackChannels.value = [];
  emit('input', selectedSlackChannels.value);
};

const fetchSlackTags = async () => {
  loading.value = true;
  const { data } = await AlertingHookService.getAllAlertingHooks({ type: AlertingHookDto.type.SLACK, itemsPerPage: -1 });
  alertingHooks.value = data!;
  loading.value = false;
};

watch(() => searchString.value, () => {
  fetchSlackTags();
});

return { __sfc: true,emit, selectedSlackChannels, loading, alertingHooks, searchString, clear, fetchSlackTags, _ref, __MACROS_useVModel, watch, AlertingHookDto, AlertingHookService }
}

})